// Fenetre d'ouverture des inscriptions pour la saison en cours
export const SUBSCRIPTION_SEASON = 11;
export const SUBSCRIPTION_OPEN = false;
export const SUBSCRIPTION_END_DATE = new Date("2026-09-11T23:59:59");
